// src/components/NEPAAlertCard.js
import React from "react";

export default function NEPAAlertCard({ alert }) {
  if (!alert) return null;

  return (
    <div style={{
      border: "1px solid #e6e6e9",
      padding: 14,
      borderRadius: 8,
      marginBottom: 12,
      boxShadow: "0 1px 2px rgba(0,0,0,0.03)"
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontSize: 16, fontWeight: 600 }}>{alert.disco || "DisCo"}</div>
        <div style={{ fontSize: 12, color: "#666" }}>{alert.fetchedAt ? new Date(alert.fetchedAt).toLocaleString() : ""}</div>
      </div>

      <div style={{ marginTop: 8 }}>
        {alert.location && <div style={{ fontSize: 13, color: "#333" }}><strong>Location:</strong> {alert.location}</div>}
        {(alert.start || alert.time) && (
          <div style={{ fontSize: 13, color: "#333", marginTop: 6 }}>
            {alert.start && <span><strong>Start:</strong> {alert.start} </span>}
            {alert.time && <span style={{ marginLeft: 8 }}><strong>Time:</strong> {alert.time}</span>}
          </div>
        )}
        {alert.description && <p style={{ marginTop: 10, lineHeight: 1.4 }}>{alert.description}</p>}
        {alert.sourceUrl && <a href={alert.sourceUrl} target="_blank" rel="noreferrer">View source</a>}
      </div>
    </div>
  );
}
